var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bootstrap-scoped pagination-component" }, [
    _vm.tablePagination
      ? _c("div", { staticClass: "pagination-description" }, [
          _vm._v(
            "\n    Displaying " +
              _vm._s(_vm.tablePagination.from) +
              " to " +
              _vm._s(_vm.tablePagination.to) +
              " of " +
              _vm._s(_vm.tablePagination.total) +
              " items\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tablePagination && _vm.lastPage > _vm.firstPage,
            expression: "tablePagination && lastPage > firstPage",
          },
        ],
        staticClass: "pagination",
        class: _vm.$_css.wrapperClass,
      },
      [
        _c("li", { staticClass: "page-item" }, [
          _c(
            "a",
            {
              staticClass: "page-link",
              class: [
                "btn-nav",
                _vm.$_css.linkClass,
                _vm.isOnFirstPage ? _vm.$_css.disabledClass : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.loadPage(_vm.firstPage)
                },
              },
            },
            [_vm._v("\n        First\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "page-item" }, [
          _c(
            "a",
            {
              staticClass: "page-link",
              class: [
                "btn-nav",
                _vm.$_css.linkClass,
                _vm.isOnFirstPage ? _vm.$_css.disabledClass : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.loadPage("prev")
                },
              },
            },
            [_vm._v("\n        Previous\n      ")]
          ),
        ]),
        _vm._v(" "),
        _vm.notEnoughPages
          ? [
              _vm._l(_vm.totalPage, function (n, i) {
                return [
                  _c("li", { staticClass: "page-item" }, [
                    _c("a", {
                      key: i,
                      staticClass: "page-link",
                      class: [
                        _vm.$_css.pageClass,
                        _vm.isCurrentPage(i + _vm.firstPage)
                          ? _vm.$_css.activeClass
                          : "",
                      ],
                      domProps: { innerHTML: _vm._s(n) },
                      on: {
                        click: function ($event) {
                          return _vm.loadPage(i + _vm.firstPage)
                        },
                      },
                    }),
                  ]),
                ]
              }),
            ]
          : [
              _vm._l(_vm.windowSize, function (n, i) {
                return [
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: _vm.isCurrentPage(
                        _vm.windowStart + i + _vm.firstPage - 1
                      )
                        ? "active"
                        : "",
                    },
                    [
                      _c("a", {
                        key: i,
                        staticClass: "page-link",
                        domProps: {
                          innerHTML: _vm._s(_vm.windowStart + n - 1),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.loadPage(
                              _vm.windowStart + i + _vm.firstPage - 1
                            )
                          },
                        },
                      }),
                    ]
                  ),
                ]
              }),
            ],
        _vm._v(" "),
        _c("li", { staticClass: "page-item" }, [
          _c(
            "a",
            {
              staticClass: "page-link",
              class: [
                "btn-nav",
                _vm.$_css.linkClass,
                _vm.isOnLastPage ? _vm.$_css.disabledClass : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.loadPage("next")
                },
              },
            },
            [_vm._v("\n        Next\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "page-item" }, [
          _c(
            "a",
            {
              staticClass: "page-link",
              class: [
                "btn-nav",
                _vm.$_css.linkClass,
                _vm.isOnLastPage ? _vm.$_css.disabledClass : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.loadPage(_vm.lastPage)
                },
              },
            },
            [_vm._v("\n        Last\n      ")]
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }